// import { t } from 'i18next';
import React, { createContext, useState } from 'react';
// import { useTranslation } from 'react-i18next';
export const ThemeContext = createContext();
export const ThemeProvider = ({ children }) => {
  // const { t } = useTranslation();
  const [theme, setTheme] = useState('light');
  const initialName = window.location.pathname == "/chat/:id" ? "Chat" : ""
  const [navbarName, setNavbarName] = useState(initialName);
  const colorList = [
    "rgb(37, 99, 235)",
    "rgb(59, 130, 247)",
    "rgb(0, 51, 102)",     // Navy Blue
    "rgb(128, 128, 128)",  // Gray
    "rgb(34, 139, 34)",    // Forest Green
    "rgb(128, 0, 128)",    // Purple
    "rgb(139, 0, 0)",      // Dark Red
    "rgb(218, 165, 32)",   // Goldenrod
    "rgb(0, 128, 128)",    // Teal
    "rgb(255, 255, 255)",  // White
    "rgb(0, 0, 0)",        // Black
    "rgb(112, 128, 144)"   // Slate Gray
  ];
  var deviceType = localStorage.getItem("device_type")
  var isMobile = (deviceType == "mobile" || deviceType == "tablet")
  const [toggleSidebar, setToggleSidebar] = useState(isMobile ? false : true );
  const [color, setColor] = useState(colorList[0]);
  const [conversationId, setConversationId] = useState("")
  const [titleChatName, setTitleChatName] = useState(null)
  const [titleDashboardName, setTitleDashboardName] = useState(null);
  const [dashboardTitleId, setDashboardId] = useState("")
  const [isStar, setIsStar] = useState(false)
  
  const [activeTab, setActiveTab] = useState(parseInt(localStorage.getItem("chat_type") ?? 1) ?? 1)
  const [activeTabCopy, setActiveTabCopy] = useState(parseInt(localStorage.getItem("chat_type") ?? 1) ?? 1)

  const toggleTheme = () => {
    console.log("click")
    setTheme(theme === 'light' ? 'dark' : 'light');
  };
  const toggleNavbarName = (name) => {
    console.log("click1")
    setNavbarName(name);
  };
  const onToggleSidebar = () => {
    localStorage.setItem("toggle_state", !toggleSidebar)
    setToggleSidebar((prevState) => !prevState)
  }
  const onChangeConversationId = (id) => {
    setConversationId(id)
  }
  const onChangeColor = (col) => {
    setColor(col)
  }
  const onChangeTitleChatName = (name) => {
    setTitleChatName(name)
  }
  const onChangeTitleDashboardName = (name) => {
    setTitleDashboardName(name)
  }
  const onChangeDashboardId = (id) => {
    console.log(id)
    setDashboardId(id)
  }
  
  const onChangeStar = () => {
    setIsStar((prevState) => !prevState)
  }
  const onChangeActiveTab = (name) => {
    setActiveTab(name)
    setActiveTabCopy(name)
  }
  let rgbColor = color;
  let alpha = 0.1;
  // Convert to rgba format
  let rgbaColor = rgbColor.replace('rgb', 'rgba').replace(')', `, ${alpha})`)
  const contentWidth = toggleSidebar ? (window.innerWidth * 0.81) - 50 : window.innerWidth - 50
  const chatContentWidth = toggleSidebar ? (contentWidth * 0.79) - 50 : (contentWidth)
  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, navbarName, 
    toggleNavbarName, toggleSidebar, onToggleSidebar, 
    color, rgbaColor, conversationId, onChangeConversationId, activeTabCopy, dashboardTitleId, onChangeDashboardId, onChangeColor, 
    contentWidth, onChangeTitleChatName, titleChatName, onChangeTitleDashboardName, titleDashboardName, chatContentWidth, isStar, onChangeStar, activeTab, onChangeActiveTab }}>
      {children}
    </ThemeContext.Provider>
  );
};